import { LandType } from "../Api/ApiServer";

export const getCurrentGiff = (land?: LandType) => {
    if (!land)
        return "";
    else {
        switch (land) {
            case LandType.Flat:
                return '/ryc_house_flat.gif';
            case LandType.Cross:
                return '/ryc_house_cross.gif';
            case LandType.Dig:
                return '/ryc_house_dig.gif';

            case LandType.LongFlat:
                return '/ryc_house_long_flat.gif';
            default:
                return "";
        }
    }
}